// Permission modules and actions shared config
export const moduleActions: Record<string, string[]> = {
  dashboard: ['View'],
  storeCategory: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  itemCategory: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  itemSubCategory: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  choiceGroup: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  choices: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  storeOwner: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  store: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  customer: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  item: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  deliveryBoy: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  coupon: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  cms: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  faq: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  storeReview: ['View', 'Approve', 'Delete'],
  deliveryReview: ['View', 'Approve', 'Delete'],
  order: ['View'],
  inventory: ['View', 'Add', 'Export'],
  settings: ['View', 'Edit'],
  referFriend: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  newsLetter: ['View', 'Delete', 'Block', 'Unblock'],
  deliveryBoyMap: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  reports: ['View', 'Export'],
  promotionalAndOffers: ['View', 'Add', 'Edit', 'Delete', 'Block', 'Unblock'],
  wallet: ['View', 'Credit', 'Debit'],
  settlement: ['View', 'Settle', 'Export'],
  pushNotification: ['Add'],
  joinUs: ['View'],
};

export const modules = Object.keys(moduleActions);
export const actions = Array.from(new Set(Object.values(moduleActions).flat())); 